import axiosServices from "../utils/axios";

import type { PickList } from "../utils/types/pickList";

interface FetchPickListApiResponse {
  data: PickList[];
}

export const fetchPickListData = async () => {
  const response = await axiosServices.get<FetchPickListApiResponse>("/pickList");
  return response.data;
};

export const updatePickList = async (
  id: string,
  data: {
    [key: string]: any;
    id: string;
  }
) => {
  try {
    const response = await axiosServices.put(`/pickList/${id}`, data);
    return response?.data;
  } catch (error: any) {
    console.error("Error updating pick list:", error?.message || error);
    throw new Error(
      error?.response?.data?.message || "Failed to update pick list item"
    );
  }
};

export const deletePickList = async (id: string) => {
  try {
    const response = await axiosServices.delete(`/pickList/${id}`);
    return { success: response?.data?.success, id, message: response?.data?.message };
  } catch (error: any) {
    throw new Error(error?.data?.message || "Failed to delete the data");
  }
};

export const addPickList = async (data: { [key: string]: any }) => {
  try {
    const response = await axiosServices.post(`/pickList`, data);
    return response.data.data;
  } catch (error: any) {
    throw new Error(
      error?.data?.message || "Failed to add the new pick list item"
    );
  }
};
